<div id="slider">
  @for (b of banner; track b) {
    <figure>
      <div class="banner_slider">
        <img src="{{ b.image }}" alt="slider-1">
        <h6>{{ b.title }}</h6>
        <p>{{ b.description }}</p>
      </div>
    </figure>
  }
</div>